<section>
  <nav fxLayout="row" fxLayoutGap="4px">
    <a [ngClass]="{'active': nav.slug === 'how-it-works'}"
       fxLayoutAlign="center center"
       routerLink="/how-it-works">What</a>
    <a [ngClass]="{'active': nav.slug === 'why-balikbayad'}"
       fxLayoutAlign="center center"
       routerLink="/why-balikbayad">Why</a>
    <a [ngClass]="{'active': nav.slug === 'getting-a-loan'}"
       fxLayoutAlign="center center"
       routerLink="/getting-a-loan">How</a>
  </nav>
</section>
